import { MM } from "@pdfking/quantity"
import type { PageShape } from "@pdfking/renderer-api"
import { FullMethodDispatcher } from "@pdfking/tfunc"

import type { CalendarArea, CalendarDesign, CalendarPageKind, DrawPage } from "#internal"

import { DrawNotepadPage } from "../notepad/DrawNotepadPage"
import { NotebookBackground } from "../types/NotebookBackground"
import { Area } from "./Area"
import { BackCoverAreas } from "./BackCoverAreas"
import { CalendarCoverPage } from "./CalendarCoverPage"
import { CalendarFrame } from "./CalendarFrame"
import { CalendarPagePlan } from "./CalendarPagePlan"
import { GenerateCalendarLayout } from "./GenerateCalendarLayout"

/** A calendar of `design`'s page, as `page` has it, drawn as its plan has it
 * (see CalendarPagePlan): a cover's page the pattern with the year over the
 * footer (see CalendarCoverPage), a pad's sheet, a month or a week the
 * design's page of it, the whole year its page of the year, a picture the
 * page whole, the back cover BackCoverAreas, notes a lined page. */
export const DrawCalendarPage =
  (design: CalendarDesign): DrawPage =>
  page => {
    const boxes = CalendarFrame(page, true)
    const draw = (areas: CalendarArea[]) =>
      GenerateCalendarLayout({ areas, footer: true, page, spot_year: false })
    return FullMethodDispatcher<[CalendarPageKind], PageShape[]>({
      back: () => draw(BackCoverAreas(boxes)),
      case: () => draw(CalendarCoverPage(boxes)),
      cover: () => draw(design.cover(boxes)),
      month: ({ month }) => draw(design.page(boxes, month)),
      notes: () =>
        DrawNotepadPage({
          background: NotebookBackground.LINES,
          footer: true,
          page,
          pitch: MM(10.25),
        }),
      picture: ({ month }) => draw([Area.picture(boxes.page, month)]),
      sheet: ({ sheet }) => draw(design.page(boxes, sheet)),
      week: ({ week }) => draw(design.page(boxes, week)),
      year: () => draw(design.page(boxes, 1)),
    })(CalendarPagePlan(design.pages, page))
  }
